/**
 * Exportación a Excel del historial global (sale de HistorialGlobal.jsx para poder probarla con
 * node: utils/exportarHistorial.test.js).
 *
 * Fase 3c: dos columnas al final, Provincia y Localidad, que son las del MOVIMIENTO (vacías en los
 * eventos que no son movimientos). Sin el código INE (decidido por Iban).
 */

export function fmtFecha(iso) {
  // El backend devuelve `fecha` como DATEONLY (YYYY-MM-DD) — sin hora.
  // Para hora exacta de registro, usar created_at en tooltip.
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString('es-ES', {
    day: '2-digit', month: '2-digit', year: 'numeric',
  });
}

export const CABECERA_HISTORIAL = [
  'Fecha', 'Scope', 'Tipo evento', 'Ref', 'Activo', 'Usuario', 'Registró', 'Motivo', 'Notas',
  'Provincia', 'Localidad',
];

export function toAOA(rows) {
  // «Notas» (19/10, Fase 2): en un evento `nota` es la nota que escribió una persona; en los demás,
  // el detalle que dejó quien lo registró. El servidor ya la devuelve en cada evento.
  const body = rows.map((r) => [
    fmtFecha(r.fecha), r.scope, r.event_type, r.referencia,
    r.asset_nombre, r.user_nombre || '', r.creator_nombre || '',
    r.motivo || '', r.notas || '',
    r.ubicacion_provincia || '', r.ubicacion_localidad || '',
  ]);
  return [CABECERA_HISTORIAL, ...body];
}
